import { Box, Card, Typography, useMediaQuery, useTheme } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { RoutesConfig } from "../router/types";
import { useNavigate } from "react-router-dom";

interface UserTypeCardProps {
  title: string;
  onClick: () => void;
  isMobile?: boolean;
}

const UserTypeCard: React.FC<UserTypeCardProps> = ({
  title,
  onClick,
  isMobile,
}) => (
  <Card
    onClick={onClick}
    elevation={0}
    sx={{
      width: isMobile ? 150 : 200,
      height: isMobile ? 150 : 200,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      border: "2px solid #0A0C33",
      borderRadius: "8px",
      "&:hover": {
        transform: "translateY(-5px)",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        bgcolor: "#0A0C33",
        "& .MuiSvgIcon-root": {
          color: "white",
        },
        "& .MuiTypography-root": {
          color: "white",
        },
      },
      "&:active": {
        bgcolor: "#0A0C33",
        "& .MuiSvgIcon-root": {
          color: "white",
        },
        "& .MuiTypography-root": {
          color: "white",
        },
      },
    }}
  >
    <PersonIcon sx={{ fontSize: 64, color: "#0A0C33", mb: 2 }} />
    <Typography variant="h6" color="#0A0C33">
      {title}
    </Typography>
  </Card>
);

const UserOptions = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleUserTypeSelect = (type: string) => {
    switch (type) {
      case "cliente":
        navigate(RoutesConfig.ASSOCIARCLIENTE.path);
        break;
      case "analista":
        navigate(RoutesConfig.ASSOCIARANALISTA.path);
        break;
      case "admin":
        navigate(RoutesConfig.ASSOCIARADMIN.path);
        break;
      default:
        console.log("Tipo selecionado: Desconhecido");
        break;
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        p: isMobile ? 4 : 11,
      }}
    >
      <Typography variant="h5" sx={{ mb: 6, color: "#0A0C33" }}>
        Selecione o tipo de usuário a ser associado:
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 4,
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <UserTypeCard
          title="Cliente"
          isMobile={isMobile}
          onClick={() => handleUserTypeSelect("cliente")}
        />
        <UserTypeCard
          title="Analista"
          isMobile={isMobile}
          onClick={() => handleUserTypeSelect("analista")}
        />
        <UserTypeCard
          title="Administrador"
          isMobile={isMobile}
          onClick={() => handleUserTypeSelect("admin")}
        />
      </Box>
    </Box>
  );
};

export default UserOptions;
